export default __webpack_public_path__ + "static/media/water.b043da24.png";